<template>
    <div class="rhythmClass">
        <el-col :span="24" class="imgStyle" align="left">
            <div class="stateBice">
                <div v-viewer class="coinBase">
                    <img :src="heart.questionDto.detailInfo.imgUrl" alt="" title="点击放大">
                </div>
            </div>
            <div class="fangda">
                <el-button icon="el-icon-search" class="aginOnce">放大查看</el-button>
                <div v-viewer style="height:100%"><img :src="heart.questionDto.detailInfo.imgUrl" alt="" title="点击放大"></div>
            </div>
            <div class="userText">
                <el-input
                    type="textarea"
                    class="vimText"
                    placeholder="请在此处输入文字答题"
                    v-model="originalityVal"
                    @change="changeOriginalityVal"
                    maxlength="350"
                    show-word-limit
                >
                </el-input>
            </div>
        </el-col>
    </div>
</template>
<script>
import updataImg from '../../components/updataImg'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"creativeTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                originalityVal:'',
                maxImg:'',
                answerType:null,
            }
        },
        components:{
            updataImg
        },
        watch: {
            'originalityVal':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                if(this.allAnswer){
                    this.originalityVal = this.allAnswer.obj.originalityVal
                    this.answerType = this.allAnswer.obj.answerType
                }
            })
        },
        methods:{
            changeAnswerType(val){
                this.answerType = val.answerType
            },
            changeOriginalityVal(){
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .imgStyle{
            position: absolute;
            top: 0%;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 15px 18px;
            .stateBice{
                height: 63%;
                width: 100%;
                pointer-events: all;
                text-align: center;
                .coinBase{
                    position: relative;
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    cursor: pointer;
                    display: inline-block;
                    img{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                        max-height: 100%;
                        max-width: 100%;
                    }
                }
            }
            .fangda{
                height: 5%;
                width: 100%;
                margin: 0.7% 0 0.3% 0;
                background: #fff;
                overflow:hidden;
                position: relative;
                .aginOnce{
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%,0%);
                    height: 25px;
                    line-height: 0px;
                    box-sizing: border-box;
                    padding: 5px 15px;
                    font-size: 12px;
                    pointer-events: none;
                    z-index: 999999999;
                    cursor: pointer;
                }
                img{
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%,0%);
                    height: 24px;
                    width: 95px;
                    cursor: pointer;
                }
            }
            .userText{
                height: 29%;
                width: 100%;
                text-align: center;
                .vimText{
                    height: 100%;
                    width: 85%;
                }
            }
        }
    }
</style>
<style>
    .userText .vimText .el-textarea__inner{
        height: 100% !important;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/creativeTopic.vue